import { injectIntl } from "react-intl";
import moment from "moment";
import "moment/locale/de";
import momentLocalizer from "react-widgets-moment";
import DateTimePicker from "react-widgets/lib/DateTimePicker";

import { InputGroup } from "./Form";
import { intlShape } from "../shapes";
import { handleFormikValueChange } from "../utils/formikUtils";

type Props = {
  showSelectTime?: boolean;
  showSelectDate?: boolean;
  editFormat?: string;
  name?: string;
  disabled?: boolean;
  defaultValue?: $TSFixMe; // TODO: PropTypes.instanceOf(Date)
  minDate?: $TSFixMe; // TODO: PropTypes.instanceOf(Date)
  values?: $TSFixMe; // TODO: PropTypes.instanceOf(Object)
  intl?: intlShape;
  timeSelectStep?: number;
  isSubmitting?: boolean;
  format?: string;
  placeholder?: string;
};

function DateTimeInput(props: Props) {
  // @ts-expect-error TS(7017) FIXME: Element implicitly has an 'any' type because type ... Remove this comment to see the full error message
  moment.locale(global.configuration.locale);
  // @ts-expect-error TS(2554) FIXME: Expected 0 arguments, but got 1.
  momentLocalizer(moment);

  const {
    intl,
    defaultValue,
    showSelectTime,
    showSelectDate,
    timeSelectStep,
    minDate,
    values,
    name,
    disabled,
    isSubmitting,
    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    format = intl.formatMessage({ id: "placeholder.datetime_format" }),
    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    placeholder = intl.formatMessage({ id: "placeholder.datetime_format" }),
  } = props;

  const dateTimePicker = (
    <DateTimePicker
      // @ts-expect-error TS(2322) FIXME: Type '{ className: string; date: boolean; time: bo... Remove this comment to see the full error message
      className="date-time-input"
      date={showSelectDate || false}
      time={showSelectTime || false}
      editFormat={format}
      format={format}
      placeholder={placeholder}
      defaultValue={defaultValue}
      onChange={(value) => handleFormikValueChange(props, value)}
      // @ts-expect-error TS(2538) FIXME: Type 'undefined' cannot be used as an index type.
      value={values[name]}
      data-testid={name}
      step={timeSelectStep || 10}
      min={minDate || (showSelectDate && new Date())}
      disabled={disabled || isSubmitting}
    />
  );

  return <InputGroup {...props}>{dateTimePicker}</InputGroup>;
}

export default injectIntl(DateTimeInput);
